module.exports = __webpack_public_path__ + "img/1.c06622d1.png";